import { writable } from "svelte/store";
import defaultsDeep from "lodash/defaultsDeep";
import { get } from "svelte/store";
import copyDefault from "../constants/copyDefault";
import copyDefaultDemo from "../constants/copyDefault.demo";
import { isDemoMode, isEditorMode } from "./mode";
import merge from "lodash/merge";

export type CustomField = {
  name: string;
  type: "date_input" | "text_input" | "checkbox";
  default_value: boolean | string;
  is_required: boolean;
  validation: string;
  validation_config: string;
  identifier: string;
};

export type SettingsStore = {
  campaign?: string;
  secondary_channels?: string[];
  routes?: Record<string, unknown>;
  channels?: string[];
  requiresLinkedInAuth?: boolean;
  [key: string]: unknown;
  showDeliveryZones?: boolean;
  deliveryZones?: unknown[];
  uploadMimeTypes?: string[];
  entry_validations?: { name: string }[];
  custom_fields?: CustomField[];
  isGiftLandingPreviewEnabled?: boolean;
};

export const updateSettings = (config: Record<string, unknown>) => {
  settingsStore.set(defaultsDeep(config, get(settingsStore)) as SettingsStore);
};

export function initStore() {
  const store = writable<SettingsStore>();
  let defaultSettings;
  if (isDemoMode()) {
    // We need a deep merge so that we don't need to override the whole object
    defaultSettings = merge(copyDefault, copyDefaultDemo);
  } else if (isEditorMode()) {
    defaultSettings = { ...copyDefault };
  } else {
    defaultSettings = { ...copyDefault, v2: { flow: [] } };
  }
  store.set(defaultSettings as SettingsStore);
  return store;
}

export const settingsStore = initStore();
